<script setup>
import { dateRanges } from '../helpers/DatePickerHelper';

defineProps({
  selectedRange: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['setRange']);

const setDateRange = range => {
  emit('setRange', range);
};
</script>

<template>
  <!-- No celular os atalhos vão em duas colunas, na largura da folha; do md para cima, a coluna
  de 200 px de sempre. -->
  <div class="w-full flex flex-col items-start md:w-[200px]">
    <!-- O título sai como a tradução o escreve. O `capitalize` punha maiúscula em cada palavra:
    "Intervalo De Data". -->
    <h4 class="w-full px-5 py-4 text-xs font-bold text-start text-n-slate-10">
      {{ $t('DATE_PICKER.DATE_RANGE_OPTIONS.TITLE') }}
    </h4>
    <div class="grid grid-cols-2 w-full md:flex md:flex-col md:items-start">
      <template v-for="range in dateRanges" :key="range.label">
        <div
          v-if="range.separator"
          class="col-span-2 w-full border-t border-n-strong"
        />
        <button
          class="w-full px-5 py-3 text-sm font-medium truncate border-none rounded-none text-start hover:bg-n-alpha-2 dark:hover:bg-n-solid-3"
          :class="[
            range.value === selectedRange
              ? 'text-n-slate-12 bg-n-alpha-1 dark:bg-n-solid-active'
              : 'text-n-slate-12',
            range.value === 'custom' ? 'col-span-2 md:col-span-1' : '',
          ]"
          @click="setDateRange(range)"
        >
          {{ $t(range.label) }}
        </button>
      </template>
    </div>
  </div>
</template>
